// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__vBTw8","sm":"Tag_sm__aOyU5"};